import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { StockChart, Chart } from 'angular-highcharts';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';
import { interval } from 'rxjs';

@Component({
  selector: 'app-battery-instant',
  templateUrl: './battery-instant.component.html',
  styleUrls: ['./battery-instant.component.css']
})
export class BatteryInstantComponent implements OnInit {
  batteryInstant: Chart;
  constructor(
    private http: HttpClient,
    private meta: Meta,
    private titleService: Title
  ) {
    this.meta.updateTag({ name: 'title', content: 'Wheatherman - battery instant' });
    this.meta.updateTag({ name: 'description', content: 'Wheatherman - battery instant' });
    this.meta.updateTag({ name: 'keywords', content: 'Wheatherman - battery instant' });
    this.titleService.setTitle('Wheatherman');
   }

  ngOnInit() {
    this.lastValueBattery();
    interval(1000 * environment.timeToRefresh).subscribe(x => {
      this.refrash();
    });
  }

  lastValueBattery() {
    this.http.get(`${environment.apiUrl}/batteryInstant.php`)
      .subscribe((res: any) => {
        console.log('last battery', res);
        this.batteryInstant = new Chart({
          chart: {
            type: 'gauge',
            plotBackgroundColor: null,
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false
          },
          pane: {
            startAngle: -150,
            endAngle: 150,
            background: [{
              backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                  [0, '#FFF'],
                  [1, '#333']
                ]
              },
              borderWidth: 0,
              outerRadius: '109%'
            }, {
              backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                  [0, '#333'],
                  [1, '#FFF']
                ]
              },
              borderWidth: 1,
              outerRadius: '107%'
            }, {
              // default background
            }, {
              backgroundColor: '#DDD',
              borderWidth: 0,
              outerRadius: '105%',
              innerRadius: '103%'
            }]
          },

          // the value axis
          yAxis: {
            min: 0,
            max: 500,

            minorTickInterval: 'auto',
            minorTickWidth: 1,
            minorTickLength: 10,
            minorTickPosition: 'inside',
            minorTickColor: '#666',

            tickPixelInterval: 30,
            tickWidth: 2,
            tickPosition: 'inside',
            tickLength: 10,
            tickColor: '#666',
            labels: {
              step: 2,
              rotation: 'auto'
            },
            title: {
              text: '%'
            },
            plotBands: [{
              from: 0,
              to: 25,
              color: '#DF5353' // red
            }, {
              from: 25,
              to: 75,
              color: '#DDDF0D' // yellow
            }, {
              from: 75,
              to: 100,
              color: '#55BF3B' // green
            }, {
              from: 100,
              to: 500,
              color: '#DF5353' // red
            }]
          },
          rangeSelector: {
            selected: 1
          },
          title: {
            text: 'Instant Battery'
          },
          time: {
            useUTC: false,
            timezoneOffset: 3600,
            timezone: 'Europe/Rome'
          },
          series: [{
            name: 'Bat.',
            data: res,
            tooltip: {
              valueSuffix: ' %'
            }
          }]
        } as any);
      });

  }

  // add point to chart serie
  refrash() {
    // this.listValueTemperature()
    this.http.get(`${environment.apiUrl}/batteryInstant.php`)
      .subscribe((res: any) => {
        console.log('battery update', res);
        var point = this.batteryInstant.removePoint(0);
        var point = this.batteryInstant.addPoint(res);
        // point.update({series: [{data: res}]});
      });
  }

}
